import { render, staticRenderFns } from "./faq-page.vue?vue&type=template&id=1701373a&scoped=true&"
import script from "./faq-page.vue?vue&type=script&lang=js&"
export * from "./faq-page.vue?vue&type=script&lang=js&"
import style0 from "./faq-page.vue?vue&type=style&index=0&id=1701373a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1701373a",
  null
  
)

export default component.exports